import * as React from 'react';
import { Heading, Text } from '@grandvisionhq/elements';
import { ButtonOutline } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const OrderHeader = ({ orderDate , orderNumber , shipmentStatus , orderStatus , paymentStatus , isOrderWorkflowStatusEnabled =false , onReorder , shouldShowOrderDate ,  })=>{
    const { dateTime , getLabel  } = useIntl();
    const labels = {
        order: getLabel('common.order'),
        paymentStatus: getLabel('account.order.paymentStatus.label'),
        shipmentState: getLabel('account.order.shipmentState.label'),
        orderCreatedDate: getLabel('account.order.created.date'),
        reOrder: getLabel('account.action.reOrder')
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-header"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h1",
        variant: "small"
    }, labels.order, ": ", orderNumber), shouldShowOrderDate && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, labels.orderCreatedDate, ": ", dateTime.formatMidsizeDate(orderDate)), /*#__PURE__*/ React.createElement("div", {
        className: "order-header__status"
    }, isOrderWorkflowStatusEnabled ? orderStatus && /*#__PURE__*/ React.createElement("div", {
        className: "order-header__shipment"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        color: "text-secondary"
    }, labels.shipmentState, ": ", orderStatus)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "order-header__status-detail"
    }, paymentStatus && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        color: "text-secondary"
    }, labels.paymentStatus, ": ", paymentStatus)), shipmentStatus && /*#__PURE__*/ React.createElement("div", {
        className: "order-header__shipment"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        color: "text-secondary"
    }, labels.shipmentState, ": ", shipmentStatus)))), /*#__PURE__*/ React.createElement("div", {
        className: "order-header__links"
    }, onReorder && /*#__PURE__*/ React.createElement(ButtonOutline, {
        className: "header-reorder-button",
        onPress: ()=>onReorder()
    }, labels.reOrder)));
};

export { OrderHeader as default };
//# sourceMappingURL=OrderHeader.js.map
